import React from "react";
import { Row, Col, Tooltip, Card, Drawer, Button, Modal } from "antd";
import { withRouter } from "react-router";
import "antd/dist/antd.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { noAuthlist } from "../api/Apis";
import { withAppContext } from "../store/contextStore";
import { CloseOutlined } from "@ant-design/icons";
import BuyerAgentProfile from "../components/Card/BuyerAgentCard";

export class Advertisement extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loanVisible:     false,
      smallAdsList:    [],
      bigAdsList:      [],
      showAdPage:      false,
      specificAdPage:  false,
      adPageUrl:       "",
      propertyZipCode: "",
      lendersDetails:  [],
      agentsDetails:   [],
      otherAds:        false,
      adType:          "Square",
      adWhereToShow:   "Homes",
      adLimit:         "0",
      zipCode:         [],
    };
  }

  componentDidMount = () => {
    AOS.init({ duration: 1500 });
    this.getAllUsers();
    this.getAllAgents();
    this.getAds();
  };

  componentDidUpdate(prevProps) {
    // Re-fetch if the location prop changes (e.g. switching sections in HomeBuddha)
    if (prevProps.adWhereToShow !== this.props.adWhereToShow) {
      this.getAds();
    }
  }

  getAllUsers = async () => {
    const allUsers = await noAuthlist("getUsers?userProfile=L");
    const allFilterLenders =
      allUsers.data &&
      allUsers.data.filter(
        (o) => o.subscriptionPack && parseInt(o.subscriptionPack.price) > 0
      );
    const FilterLenders =
      allFilterLenders &&
      allFilterLenders.sort((a, b) =>
        parseInt(a.subscriptionPack.price) > parseInt(b.subscriptionPack.price) ? -1 : 1
      );
    const lendersDetails = [];
    if (FilterLenders) {
      for (let singleItem of FilterLenders) {
        if (singleItem.profilePicture) {
          singleItem["AgnetProfileUrl"] =
            `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/` +
            singleItem.profilePicture[0];
        } else {
          singleItem["AgnetProfileUrl"] = "";
        }
        lendersDetails.push({ ...singleItem });
      }
      this.setState({ lendersDetails });
    }
  };

  getAllAgents = async () => {
    const allAgentsUsers = await noAuthlist("getAgents");
    const allFilterAgents =
      allAgentsUsers.data &&
      allAgentsUsers.data.filter(
        (agent) => agent.email === process.env.REACT_APP_CLIENT_AGENT_EMAIL
      );
    const agentsDetails = [];
    if (allFilterAgents) {
      for (let singleItem of allFilterAgents) {
        if (singleItem.profilePicture) {
          singleItem["AgnetProfileUrl"] =
            `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/` +
            singleItem.profilePicture[0];
        } else {
          singleItem["AgnetProfileUrl"] = "";
        }
        agentsDetails.push({ ...singleItem });
      }
      this.setState({ agentsDetails });
    }
  };

  getAds = async () => {
    if (!this.props || !this.props.adType || this.props.adType === undefined) return;

    let { otherAds, adType, adWhereToShow, adLimit, zipCode } = this.props;
    let adsQuery = {};
    const cityData = JSON.parse(localStorage.getItem("selectedCities"));

    if (!this.props.detailsPageAds) {
      let cityName = [], stateName = [], postalCode = [];
      this.props.context.state.filtersearch &&
        this.props.context.state.filtersearch.length > 0 &&
        this.props.context.state.filtersearch.forEach((eachSearch) => {
          postalCode.push(eachSearch.zipCode);
          eachSearch.multi &&
            eachSearch.multi.forEach((filterCity) => {
              cityName.push(filterCity.cityName);
              stateName.push(filterCity.stateName);
            });
        });
      cityData &&
        cityData.searchLocation &&
        cityData.searchLocation.forEach((eachCity) => {
          cityName.push(eachCity.cityName);
          stateName.push(eachCity.stateName);
        });
      if (cityName.length > 0) {
        adsQuery = { cityName: cityName.join(","), stateName: stateName.join(",") };
      }
      if (postalCode.length > 0) {
        adsQuery = { ...adsQuery, postalCode: postalCode.join(",") };
      }
    } else {
      adsQuery = {
        cityName:   this.props.cityName,
        stateName:  this.props.stateName,
        postalCode: this.props.postalCode,
      };
    }

    this.setState({
      otherAds,
      adType,
      adWhereToShow,
      adLimit,
      propertyZipCode: zipCode !== "" && zipCode !== undefined && zipCode !== null ? zipCode : [],
    });

    // ── Key fix: send both spellings so Lambda matches regardless of case ──
    adsQuery = {
      ...adsQuery,
      imageType:    adType,
      whereToShow:  adWhereToShow,   // original prop name (capital S)
      whereToshow:  adWhereToShow,   // lowercase — matches DynamoDB field name
      limit:        adLimit,
    };

    const response = await noAuthlist("getAds", adsQuery);
    if (response.success) {
      let allAds = response.data || [];

      // ── Client-side filter: only show ads whose whereToshow includes this location ──
      // This is the safety net in case the Lambda returns all ads unfiltered
      if (adWhereToShow && allAds.length > 0) {
        const filtered = allAds.filter(ad => {
          if (!ad.whereToshow) return false;
          const locations = Array.isArray(ad.whereToshow) ? ad.whereToshow : [ad.whereToshow];
          return locations.some(loc =>
            loc.toLowerCase() === adWhereToShow.toLowerCase()
          );
        });
        // Use filtered if it has results, fall back to all if filter returns nothing
        // (means Lambda already filtered correctly)
        allAds = filtered.length > 0 ? filtered : allAds;
      }

      if (adType === "Square") {
        this.setState({ smallAdsList: allAds });
      } else {
        this.setState({ bigAdsList: allAds });
      }
    }
  };

  getRandomAd = (adLength) => Math.floor(Math.random() * adLength);

  handleApproveLone = () => this.setState({ loanVisible: true });
  loanCloseModal    = () => this.setState({ loanVisible: false });

  handleShowAdPage = (url) => {
    this.setState({ adPageUrl: url });
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  render() {
    const {
      loanVisible, bigAdsList, smallAdsList, showAdPage,
      adPageUrl, propertyZipCode, lendersDetails, agentsDetails, otherAds, adType,
    } = this.state;
    const { isLogin, cityName, postalCode, stateName } = this.props;

    return (
      <>
        {adType === "Square" ? (
          <div>
            {otherAds && (
              <Row className="row-padding">
                <Card bodyStyle={{ padding: "15px" }}>
                  <Row className="font-family-style font-medium-size center-item">
                    <p className="font-and-textalign">Are you ready to buy a home?</p>
                  </Row>
                  <Row className="center-item font-family-style padding-loan-btn">
                    <Button type="primary" className="size1-loan" onClick={this.handleApproveLone}>
                      Get pre approved for a loan
                    </Button>
                  </Row>
                </Card>
              </Row>
            )}

            {smallAdsList.map((ads, idx) => (
              <div key={ads.id || idx}
                data-aos-offset="100" data-aos-delay="200" data-aos-once="true" data-aos="fade-up">
                <Row className="row-padding">
                  <Card hoverable className="modal-add1"
                    onClick={() => this.handleShowAdPage(ads.imageUrl)}
                    style={{ cursor: "pointer" }}>
                    <img
                      src={`https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/` + ads.image}
                      alt={ads.image}
                      style={{ width: "100%" }}
                    />
                  </Card>
                </Row>
              </div>
            ))}
          </div>
        ) : (
          <div
            data-aos-offset={this.props.showMatchesPage ? "0" : "100"}
            data-aos-delay={this.props.showMatchesPage ? "0" : "200"}
            data-aos-once={this.props.showMatchesPage ? "false" : "true"}
            data-aos={this.props.showMatchesPage ? "" : "fade-up"}>
            {bigAdsList.map((bigAds, idx) => (
              <Card key={bigAds.id || idx} hoverable className="modal-add1"
                style={{ marginTop: "0.7%", marginBottom: "0.7%", background: "border-box", cursor: "pointer" }}
                onClick={() => this.handleShowAdPage(bigAds.imageUrl)}>
                <img
                  src={`https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/public/` + bigAds.image}
                  alt={bigAds.image}
                  className="object-Fit"
                />
              </Card>
            ))}
          </div>
        )}

        <Drawer
          title={null} placement="bottom" width="100%" height="100%"
          mask={true} closable={true} getContainer={false}
          visible={showAdPage}
          onClose={() => this.setState({ showAdPage: false, adPageUrl: "" })}
          closeIcon={
            <Tooltip color="red" placement="left" title="Go To That's My Town">
              <CloseOutlined style={{ color: "red", fontSize: "22px", fontWeight: "bold", backgroundColor: "black", border: "1px solid grey", padding: "5px" }} />
            </Tooltip>
          }
          headerStyle={{ color: "red" }}>
          <Row>
            <Col span={24}>
              <iframe src={adPageUrl}
                style={{ position: "fixed", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%", border: "none", margin: 0, padding: 0, overflow: "hidden", zIndex: 9 }}
                title="page">
                Your browser doesn't support iframes
              </iframe>
            </Col>
          </Row>
        </Drawer>

        <Modal className="modal-black-close" visible={loanVisible}
          style={{ marginTop: "2%" }}
          onCancel={() => this.setState({ loanVisible: false })}
          footer={null}>
          <div>
            <Row>
              <div style={{ marginTop: "20px" }}>
                <h4>Get pre approved for a loan</h4>
                <p style={{ color: "#99A2C3", marginTop: "10px" }}>
                  Below are our preferred local lenders who will work with you to get your dream home.
                  If none are listed or you don't see a good match send a message to our client concierge
                  below and our team of experts will help you find an experienced lender in your area.
                </p>
              </div>
            </Row>

            {propertyZipCode !== "" && propertyZipCode !== undefined && propertyZipCode !== null &&
              lendersDetails && lendersDetails.length > 0 &&
              lendersDetails.filter(owner =>
                owner.newdata && owner.newdata.zipCodes &&
                owner.newdata.zipCodes.length > 0 &&
                owner.newdata.zipCodes.includes(propertyZipCode)
              ).slice(0, 3).map(lendersInfo => (
                <React.Fragment key={lendersInfo.id}>
                  <BuyerAgentProfile isLender={true} agentInfo={lendersInfo} viewProfileAuth={isLogin ? true : false} />
                  <hr />
                </React.Fragment>
              ))}

            {agentsDetails && agentsDetails.length > 0 &&
              agentsDetails.slice(0, 1).map(agentsInfo => (
                <React.Fragment key={agentsInfo.id}>
                  <BuyerAgentProfile isLender={true} agentInfo={agentsInfo} viewProfileAuth={isLogin ? true : false} />
                  <hr />
                </React.Fragment>
              ))}

            <Row>
              <Advertisement
                otherAds={false} adType="Rectangle" adWhereToShow="PreApprovedPopup"
                adLimit="1" cityName={cityName} postalCode={postalCode} stateName={stateName}
                detailsPageAds={true} />
            </Row>
          </div>
        </Modal>
      </>
    );
  }
}

export default withAppContext(withRouter(Advertisement));
